interface RemoveBasketPayload {
  basket_id: string
}

export class RemoveBasketRequest {
  endpointUrl: URL
  data: RemoveBasketPayload
  method = 'POST' as const
  headers: HeadersInit = { 'Content-Type': 'application/json' }

  constructor(endpoint: string, basketId: string) {
    this.endpointUrl = new URL(endpoint + 'RemoveBasket/', window.location.href)
    this.data = {
      basket_id: basketId,
    }
  }
}
